import { memo } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { Box } from "@mui/joy";
import { CompanyAvatar } from "../../../Components/Avatar/CompanyAvatar";
import { Company } from "@shared/Entities/EntityTypes";

interface CompanyListProps {
	companies?: Company[];
	onSelect(id: number): void;
	selectedId?: number;
}

export function CompanyList(props: CompanyListProps) {
	return (
		props.companies?.filter(company => company.id != -1).map((company) =>
			<CompanyListItem
				key={company.id}
				company={company}
				onSelect={props.onSelect}
				active={company.id == props.selectedId}
			/>
		)
	);
}

interface CompanyListItemProps {
	company: Company;
	onSelect(id: number): void;
	active?: boolean;
}

const CompanyListItem = memo(function CompanyListItem(props: CompanyListItemProps) {
	function onClick() {
		props.onSelect(props.company.id);
	}

	return (
		<Box
			sx={{
				borderColor: "neutral.outlinedBorder",
				backgroundColor: props.active ? "background.level1" : "background.body"
			}}
			onClick={onClick}
			className="flex p-2 border-b border-gray-300 w-full cursor-pointer"
		>
			<div>
				<CompanyAvatar widthPx={30} company={props.company} />
			</div>
			<div className="flex-grow mx-2 my-auto text-left">
				{props.company.name}
			</div>
			<div className="my-auto flex-shrink-0 tabular-nums" title="Active users">
				<AiOutlineUser /> {props.company.userCount}
			</div>
		</Box>
	);
});
